'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var baseThemeStyleName = exports.baseThemeStyleName = 'theme-base';
var flagIconClassesPrefixName = exports.flagIconClassesPrefixName = 'flag-icon';
var flagIconClassesPrefix = exports.flagIconClassesPrefix = flagIconClassesPrefixName + '-';
var flagIconModulePath = exports.flagIconModulePath = 'node_modules/flag-icon-css';


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/constants.js
// module id = 358
// module chunks = 0